import { render, staticRenderFns } from "./MenuBatchUpload.vue?vue&type=template&id=776e80c8"
import script from "./MenuBatchUpload.vue?vue&type=script&lang=ts"
export * from "./MenuBatchUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports